<div class="reset-password-container">
  <mat-card class="reset-password-card">
    <mat-card-title>RedefiniÃ§Ã£o de Senha</mat-card-title>
    <mat-card-content>
      <p>Digite a nova senha para sua conta.</p>

      <form (submit)="resetarSenha()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nova Senha</mat-label>
          <input matInput type="password" required [pattern]="senhaRegex"
            (input)="novaSenha.set($any($event.target).value)">
          @if (novaSenha() && !novaSenha().match(senhaRegex)) {
            <mat-error>
              A senha deve ter no mÃ­nimo 8 caracteres, incluir uma letra maiÃºscula, uma minÃºscula, um nÃºmero e um caractere especial.
            </mat-error>
          }
        </mat-form-field>

        <div *ngIf="novaSenha()" style="color: #555; font-size: 13px; margin: 6px 0 12px 0;">
          A senha deve conter no mÃ­nimo 8 caracteres, incluindo letra maiÃºscula, minÃºscula, nÃºmero e caractere especial.
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirme a Nova Senha</mat-label>
          <input matInput type="password" required 
            (input)="confirmarNovaSenha.set($any($event.target).value)">
          
          @if (confirmarNovaSenha() && confirmarNovaSenha() !== novaSenha()) {
            <mat-error>
              As senhas nÃ£o coincidem.
            </mat-error>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" class="full-width"
          [disabled]="!novaSenha().match(senhaRegex) || !senhasCoincidem()">
          Redefinir Senha
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>